<template>
  <div class="zhihu-login">
    <van-loading v-if="loading" color="#0084ff" vertical>
      正在完成知乎授权
    </van-loading>
    <div v-else-if="errorMessage" class="error-state">
      <p>{{ errorMessage }}</p>
      <van-button type="info" size="small" @click="startAuthorization">
        重新授权
      </van-button>
    </div>
  </div>
</template>

<script>
import { otherLogin, syncZhihuUser } from '@/api/login'
import { Toast } from 'vant'

const ZHIHU_OAUTH_HOST = 'https://openapi.zhihu.com'
const SOCIAL_LOGIN_CODE_KEY = 'socialLoginCode'
const SOCIAL_LOGIN_PROVIDER_KEY = 'socialLoginProvider'
const PROVIDER = 'zhihu'

export default {
  name: 'zhihu',
  data() {
    return {
      loading: true,
      errorMessage: ''
    }
  },
  mounted() {
    this.handleAuthorization()
  },
  methods: {
    getRedirectUri() {
      return `${window.location.origin}/zh/login`
    },
    startAuthorization() {
      this.clearSocialLogin()
      const appId = process.env.VUE_APP_ZHIHU_APP_ID
      if (!appId) {
        this.loading = false
        this.errorMessage = '知乎登录配置缺失'
        Toast(this.errorMessage)
        return
      }

      const params = new URLSearchParams({
        redirect_uri: this.getRedirectUri(),
        app_id: appId,
        response_type: 'code',
      })
      window.location.replace(`${ZHIHU_OAUTH_HOST}/authorize?${params.toString()}`)
    },
    async handleAuthorization() {
      const { authorization_code: authorizationCode } = this.$route.query
      const oauthCode = authorizationCode || ''

      // 没有授权码，说明用户还未完成授权流程，直接引导去授权
      if (!oauthCode) {
        this.startAuthorization()
        return
      }

      sessionStorage.setItem(SOCIAL_LOGIN_CODE_KEY, oauthCode)
      sessionStorage.setItem(SOCIAL_LOGIN_PROVIDER_KEY, PROVIDER)

      try {
        const res = await otherLogin({ provider: PROVIDER, code: oauthCode })
        const accessToken = res.data.access_token
        await syncZhihuUser(accessToken)
        this.clearSocialLogin()
        this.$loginCb(accessToken)
      } catch (err) {
        if (err && Number(err.code) === 61097) {
          this.$router.replace('/bind')
          return
        }
        this.clearSocialLogin()
        this.loading = false
        this.errorMessage = (err && err.msg) || '知乎登录失败'
      }
    },
    clearSocialLogin() {
      sessionStorage.removeItem(SOCIAL_LOGIN_CODE_KEY)
      sessionStorage.removeItem(SOCIAL_LOGIN_PROVIDER_KEY)
    }
  }
}
</script>

<style scoped>
.zhihu-login {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
  background: #fff;
}

.error-state {
  color: #646566;
  text-align: center;
}

.error-state p {
  margin: 0 0 16px;
}
</style>
